import { useState, useEffect } from 'react';

/**
 * 读取后台公开配置（/api/config/public）。
 * 后台修改参数后收割页即时生效，无需重新部署前端。
 */
export const usePublicConfig = () => {
  const [cfg, setCfg] = useState({});
  useEffect(() => {
    let cancelled = false;
    const base = window.location.hostname === 'localhost' ? 'http://localhost:8090/api' : '/api';
    fetch(base + '/config/public')
      .then((r) => r.json())
      .then((j) => {
        if (!cancelled && j && j.code === 200 && j.data) setCfg(j.data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return cfg;
};
